unit View.Pagamentos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewPagamentosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbapagar_id: TLabel;
    edapagar_id: TDBEdit;
    lbconta_id: TLabel;
    edconta_id: TDBEdit;
    lbmodalidade_id: TLabel;
    edmodalidade_id: TDBEdit;
    lbplano_contas_id: TLabel;
    edplano_contas_id: TDBEdit;
    lbvalor: TLabel;
    edvalor: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_multa: TLabel;
    edvalor_multa: TDBEdit;
    lbvalor_juros: TLabel;
    edvalor_juros: TDBEdit;
    lbvalor_outros: TLabel;
    edvalor_outros: TDBEdit;
    lbdata: TLabel;
    eddata: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPagamentosGet: TXDataWebClient;
    XDataClientPagamentosDelete: TXDataWebClient;
    PagamentosDataset: TXDataWebDataSet;
    PagamentosDatasetid: TIntegerField;
    PagamentosDatasetaliado_id: TIntegerField;
    PagamentosDatasetdata_base_id: TIntegerField;
    PagamentosDatasetapagar_id: TIntegerField;
    PagamentosDatasetconta_id: TIntegerField;
    PagamentosDatasetmodalidade_id: TIntegerField;
    PagamentosDatasetplano_contas_id: TIntegerField;
    PagamentosDatasetvalor: TFloatField;
    PagamentosDatasetvalor_desconto: TFloatField;
    PagamentosDatasetvalor_multa: TFloatField;
    PagamentosDatasetvalor_juros: TFloatField;
    PagamentosDatasetvalor_outros: TFloatField;
    PagamentosDatasetdata: TDateTimeField;
    PagamentosDatasetcodigo_interno: TIntegerField;
    PagamentosDatasetexcluido: TBooleanField;
    PagamentosDatasetinclusao: TDateTimeField;
    PagamentosDatasetalteracao: TDateTimeField;
    PagamentosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientPagamentosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientPagamentosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientPagamentosDeleteError(Error: TXDataClientError);
    procedure PagamentosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPagamentosEdit: TFViewPagamentosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPagamentosEdit }

procedure TFViewPagamentosEdit.btSaveClick(Sender: TObject);
begin
  if PagamentosDataset.State in dsEditModes then
  begin
        PagamentosDataset.Post;
    PagamentosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewPagamentosEdit.btDeleteClick(Sender: TObject);
begin
  if PagamentosDataset.State in dsEditModes then
    PagamentosDataset.Post;
  XDataClientPagamentosDelete.Delete(PagamentosDataset.EntitySetName,
    TJSObject(PagamentosDataset.CurrentData));
end;


class function TFViewPagamentosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPagamentosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewPagamentosEdit.InsertEntity;
begin
  PagamentosDataset.Close;
  PagamentosDataset.SetJsonData('{}');
  PagamentosDataset.Open;
  PagamentosDataset.Insert;
end;

class function TFViewPagamentosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPagamentosEdit(AForm).FInserting := AInserting;
    TFViewPagamentosEdit(AForm).FId := AId;
    TFViewPagamentosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPagamentosEdit(AForm).InsertEntity
    else
      TFViewPagamentosEdit(AForm).LoadEntity;
    TFViewPagamentosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewPagamentosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPagamentosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    PagamentosDataset.Connection.Model.DefaultSchema.FindEntityType(
      PagamentosDataset.EntitySetName
    )
  );
  XDataClientPagamentosGet.Get(PagamentosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewPagamentosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewPagamentosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPagamentosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPagamentosEdit.XDataClientPagamentosGetLoad(Response: TXDataClientResponse);
begin
  PagamentosDataset.Close;
  PagamentosDataset.SetJsonData(Response.Result);
  PagamentosDataset.Open;
  
  PagamentosDataset.Edit;  
end;

procedure TFViewPagamentosEdit.XDataClientPagamentosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewPagamentosEdit.XDataClientPagamentosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewPagamentosEdit.PagamentosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPagamentosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPagamentosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.pagamentos.form.message');
  lbMessage := TLabel.Create('view.pagamentos.form.message.label');
  btCloseMessage := TButton.Create('view.pagamentos.form.message.button');
  btCancel := TButton.Create('view.pagamentos.form.btBack');
  btSave := TButton.Create('view.pagamentos.form.btSave');
  btDelete := TButton.Create('view.pagamentos.form.btDelete');
  lbid := TLabel.Create('view.pagamentos.form.lbid');
  edid := TDBEdit.Create('view.pagamentos.form.edid');
  lbaliado_id := TLabel.Create('view.pagamentos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.pagamentos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.pagamentos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.pagamentos.form.eddata_base_id');
  lbapagar_id := TLabel.Create('view.pagamentos.form.lbapagar_id');
  edapagar_id := TDBEdit.Create('view.pagamentos.form.edapagar_id');
  lbconta_id := TLabel.Create('view.pagamentos.form.lbconta_id');
  edconta_id := TDBEdit.Create('view.pagamentos.form.edconta_id');
  lbmodalidade_id := TLabel.Create('view.pagamentos.form.lbmodalidade_id');
  edmodalidade_id := TDBEdit.Create('view.pagamentos.form.edmodalidade_id');
  lbplano_contas_id := TLabel.Create('view.pagamentos.form.lbplano_contas_id');
  edplano_contas_id := TDBEdit.Create('view.pagamentos.form.edplano_contas_id');
  lbvalor := TLabel.Create('view.pagamentos.form.lbvalor');
  edvalor := TDBEdit.Create('view.pagamentos.form.edvalor');
  lbvalor_desconto := TLabel.Create('view.pagamentos.form.lbvalor_desconto');
  edvalor_desconto := TDBEdit.Create('view.pagamentos.form.edvalor_desconto');
  lbvalor_multa := TLabel.Create('view.pagamentos.form.lbvalor_multa');
  edvalor_multa := TDBEdit.Create('view.pagamentos.form.edvalor_multa');
  lbvalor_juros := TLabel.Create('view.pagamentos.form.lbvalor_juros');
  edvalor_juros := TDBEdit.Create('view.pagamentos.form.edvalor_juros');
  lbvalor_outros := TLabel.Create('view.pagamentos.form.lbvalor_outros');
  edvalor_outros := TDBEdit.Create('view.pagamentos.form.edvalor_outros');
  lbdata := TLabel.Create('view.pagamentos.form.lbdata');
  eddata := TDBEdit.Create('view.pagamentos.form.eddata');
  lbcodigo_interno := TLabel.Create('view.pagamentos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.pagamentos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.pagamentos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.pagamentos.form.edexcluido');
  lbinclusao := TLabel.Create('view.pagamentos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.pagamentos.form.edinclusao');
  lbalteracao := TLabel.Create('view.pagamentos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.pagamentos.form.edalteracao');
  lbexclusao := TLabel.Create('view.pagamentos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.pagamentos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  PagamentosDataset := TXDataWebDataSet.Create(Self);
  PagamentosDatasetid := TIntegerField.Create(Self);
  PagamentosDatasetaliado_id := TIntegerField.Create(Self);
  PagamentosDatasetdata_base_id := TIntegerField.Create(Self);
  PagamentosDatasetapagar_id := TIntegerField.Create(Self);
  PagamentosDatasetconta_id := TIntegerField.Create(Self);
  PagamentosDatasetmodalidade_id := TIntegerField.Create(Self);
  PagamentosDatasetplano_contas_id := TIntegerField.Create(Self);
  PagamentosDatasetvalor := TFloatField.Create(Self);
  PagamentosDatasetvalor_desconto := TFloatField.Create(Self);
  PagamentosDatasetvalor_multa := TFloatField.Create(Self);
  PagamentosDatasetvalor_juros := TFloatField.Create(Self);
  PagamentosDatasetvalor_outros := TFloatField.Create(Self);
  PagamentosDatasetdata := TDateTimeField.Create(Self);
  PagamentosDatasetcodigo_interno := TIntegerField.Create(Self);
  PagamentosDatasetexcluido := TBooleanField.Create(Self);
  PagamentosDatasetinclusao := TDateTimeField.Create(Self);
  PagamentosDatasetalteracao := TDateTimeField.Create(Self);
  PagamentosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientPagamentosGet := TXDataWebClient.Create(Self);
  XDataClientPagamentosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbapagar_id.BeforeLoadDFMValues;
  edapagar_id.BeforeLoadDFMValues;
  lbconta_id.BeforeLoadDFMValues;
  edconta_id.BeforeLoadDFMValues;
  lbmodalidade_id.BeforeLoadDFMValues;
  edmodalidade_id.BeforeLoadDFMValues;
  lbplano_contas_id.BeforeLoadDFMValues;
  edplano_contas_id.BeforeLoadDFMValues;
  lbvalor.BeforeLoadDFMValues;
  edvalor.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  lbvalor_multa.BeforeLoadDFMValues;
  edvalor_multa.BeforeLoadDFMValues;
  lbvalor_juros.BeforeLoadDFMValues;
  edvalor_juros.BeforeLoadDFMValues;
  lbvalor_outros.BeforeLoadDFMValues;
  edvalor_outros.BeforeLoadDFMValues;
  lbdata.BeforeLoadDFMValues;
  eddata.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  PagamentosDataset.BeforeLoadDFMValues;
  PagamentosDatasetid.BeforeLoadDFMValues;
  PagamentosDatasetaliado_id.BeforeLoadDFMValues;
  PagamentosDatasetdata_base_id.BeforeLoadDFMValues;
  PagamentosDatasetapagar_id.BeforeLoadDFMValues;
  PagamentosDatasetconta_id.BeforeLoadDFMValues;
  PagamentosDatasetmodalidade_id.BeforeLoadDFMValues;
  PagamentosDatasetplano_contas_id.BeforeLoadDFMValues;
  PagamentosDatasetvalor.BeforeLoadDFMValues;
  PagamentosDatasetvalor_desconto.BeforeLoadDFMValues;
  PagamentosDatasetvalor_multa.BeforeLoadDFMValues;
  PagamentosDatasetvalor_juros.BeforeLoadDFMValues;
  PagamentosDatasetvalor_outros.BeforeLoadDFMValues;
  PagamentosDatasetdata.BeforeLoadDFMValues;
  PagamentosDatasetcodigo_interno.BeforeLoadDFMValues;
  PagamentosDatasetexcluido.BeforeLoadDFMValues;
  PagamentosDatasetinclusao.BeforeLoadDFMValues;
  PagamentosDatasetalteracao.BeforeLoadDFMValues;
  PagamentosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientPagamentosGet.BeforeLoadDFMValues;
  XDataClientPagamentosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewPagamentosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 751;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 691;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 691;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 691;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbapagar_id.SetParentComponent(Self);
    lbapagar_id.Name := 'lbapagar_id';
    lbapagar_id.Left := 24;
    lbapagar_id.Top := 273;
    lbapagar_id.Width := 14;
    lbapagar_id.Height := 13;
    lbapagar_id.Caption := 'apagar_id:';
    lbapagar_id.Transparent := True;
    edapagar_id.SetParentComponent(Self);
    edapagar_id.Name := 'edapagar_id';
    edapagar_id.Left := 221;
    edapagar_id.Top := 270;
    edapagar_id.Width := 200;
    edapagar_id.Height := 21;
    edapagar_id.Enabled := True;
    edapagar_id.TabOrder := 9;
    edapagar_id.Text := 'edapagar_id';
    edapagar_id.DataField := 'apagar_id';
    edapagar_id.DataSource := DataSource;
    lbconta_id.SetParentComponent(Self);
    lbconta_id.Name := 'lbconta_id';
    lbconta_id.Left := 24;
    lbconta_id.Top := 300;
    lbconta_id.Width := 14;
    lbconta_id.Height := 13;
    lbconta_id.Caption := 'conta_id:';
    lbconta_id.Transparent := True;
    edconta_id.SetParentComponent(Self);
    edconta_id.Name := 'edconta_id';
    edconta_id.Left := 221;
    edconta_id.Top := 297;
    edconta_id.Width := 200;
    edconta_id.Height := 21;
    edconta_id.Enabled := True;
    edconta_id.TabOrder := 10;
    edconta_id.Text := 'edconta_id';
    edconta_id.DataField := 'conta_id';
    edconta_id.DataSource := DataSource;
    lbmodalidade_id.SetParentComponent(Self);
    lbmodalidade_id.Name := 'lbmodalidade_id';
    lbmodalidade_id.Left := 24;
    lbmodalidade_id.Top := 327;
    lbmodalidade_id.Width := 14;
    lbmodalidade_id.Height := 13;
    lbmodalidade_id.Caption := 'modalidade_id:';
    lbmodalidade_id.Transparent := True;
    edmodalidade_id.SetParentComponent(Self);
    edmodalidade_id.Name := 'edmodalidade_id';
    edmodalidade_id.Left := 221;
    edmodalidade_id.Top := 324;
    edmodalidade_id.Width := 200;
    edmodalidade_id.Height := 21;
    edmodalidade_id.Enabled := True;
    edmodalidade_id.TabOrder := 11;
    edmodalidade_id.Text := 'edmodalidade_id';
    edmodalidade_id.DataField := 'modalidade_id';
    edmodalidade_id.DataSource := DataSource;
    lbplano_contas_id.SetParentComponent(Self);
    lbplano_contas_id.Name := 'lbplano_contas_id';
    lbplano_contas_id.Left := 24;
    lbplano_contas_id.Top := 354;
    lbplano_contas_id.Width := 14;
    lbplano_contas_id.Height := 13;
    lbplano_contas_id.Caption := 'plano_contas_id:';
    lbplano_contas_id.Transparent := True;
    edplano_contas_id.SetParentComponent(Self);
    edplano_contas_id.Name := 'edplano_contas_id';
    edplano_contas_id.Left := 221;
    edplano_contas_id.Top := 351;
    edplano_contas_id.Width := 200;
    edplano_contas_id.Height := 21;
    edplano_contas_id.Enabled := True;
    edplano_contas_id.TabOrder := 12;
    edplano_contas_id.Text := 'edplano_contas_id';
    edplano_contas_id.DataField := 'plano_contas_id';
    edplano_contas_id.DataSource := DataSource;
    lbvalor.SetParentComponent(Self);
    lbvalor.Name := 'lbvalor';
    lbvalor.Left := 24;
    lbvalor.Top := 381;
    lbvalor.Width := 14;
    lbvalor.Height := 13;
    lbvalor.Caption := 'valor:';
    lbvalor.Transparent := True;
    edvalor.SetParentComponent(Self);
    edvalor.Name := 'edvalor';
    edvalor.Left := 221;
    edvalor.Top := 378;
    edvalor.Width := 200;
    edvalor.Height := 21;
    edvalor.Enabled := True;
    edvalor.TabOrder := 13;
    edvalor.Text := 'edvalor';
    edvalor.DataField := 'valor';
    edvalor.DataSource := DataSource;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 24;
    lbvalor_desconto.Top := 408;
    lbvalor_desconto.Width := 14;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'valor_desconto:';
    lbvalor_desconto.Transparent := True;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 221;
    edvalor_desconto.Top := 405;
    edvalor_desconto.Width := 200;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := True;
    edvalor_desconto.TabOrder := 14;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    lbvalor_multa.SetParentComponent(Self);
    lbvalor_multa.Name := 'lbvalor_multa';
    lbvalor_multa.Left := 24;
    lbvalor_multa.Top := 435;
    lbvalor_multa.Width := 14;
    lbvalor_multa.Height := 13;
    lbvalor_multa.Caption := 'valor_multa:';
    lbvalor_multa.Transparent := True;
    edvalor_multa.SetParentComponent(Self);
    edvalor_multa.Name := 'edvalor_multa';
    edvalor_multa.Left := 221;
    edvalor_multa.Top := 432;
    edvalor_multa.Width := 200;
    edvalor_multa.Height := 21;
    edvalor_multa.Enabled := True;
    edvalor_multa.TabOrder := 15;
    edvalor_multa.Text := 'edvalor_multa';
    edvalor_multa.DataField := 'valor_multa';
    edvalor_multa.DataSource := DataSource;
    lbvalor_juros.SetParentComponent(Self);
    lbvalor_juros.Name := 'lbvalor_juros';
    lbvalor_juros.Left := 24;
    lbvalor_juros.Top := 462;
    lbvalor_juros.Width := 14;
    lbvalor_juros.Height := 13;
    lbvalor_juros.Caption := 'valor_juros:';
    lbvalor_juros.Transparent := True;
    edvalor_juros.SetParentComponent(Self);
    edvalor_juros.Name := 'edvalor_juros';
    edvalor_juros.Left := 221;
    edvalor_juros.Top := 459;
    edvalor_juros.Width := 200;
    edvalor_juros.Height := 21;
    edvalor_juros.Enabled := True;
    edvalor_juros.TabOrder := 16;
    edvalor_juros.Text := 'edvalor_juros';
    edvalor_juros.DataField := 'valor_juros';
    edvalor_juros.DataSource := DataSource;
    lbvalor_outros.SetParentComponent(Self);
    lbvalor_outros.Name := 'lbvalor_outros';
    lbvalor_outros.Left := 24;
    lbvalor_outros.Top := 489;
    lbvalor_outros.Width := 14;
    lbvalor_outros.Height := 13;
    lbvalor_outros.Caption := 'valor_outros:';
    lbvalor_outros.Transparent := True;
    edvalor_outros.SetParentComponent(Self);
    edvalor_outros.Name := 'edvalor_outros';
    edvalor_outros.Left := 221;
    edvalor_outros.Top := 486;
    edvalor_outros.Width := 200;
    edvalor_outros.Height := 21;
    edvalor_outros.Enabled := True;
    edvalor_outros.TabOrder := 17;
    edvalor_outros.Text := 'edvalor_outros';
    edvalor_outros.DataField := 'valor_outros';
    edvalor_outros.DataSource := DataSource;
    lbdata.SetParentComponent(Self);
    lbdata.Name := 'lbdata';
    lbdata.Left := 24;
    lbdata.Top := 516;
    lbdata.Width := 14;
    lbdata.Height := 13;
    lbdata.Caption := 'data:';
    lbdata.Transparent := True;
    eddata.SetParentComponent(Self);
    eddata.Name := 'eddata';
    eddata.Left := 221;
    eddata.Top := 513;
    eddata.Width := 200;
    eddata.Height := 21;
    eddata.Enabled := True;
    eddata.TabOrder := 18;
    eddata.Text := 'eddata';
    eddata.DataField := 'data';
    eddata.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 543;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 540;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 19;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 570;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 567;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 20;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 597;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 594;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 21;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 624;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 621;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 22;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 651;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 648;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 23;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := PagamentosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    PagamentosDataset.SetParentComponent(Self);
    PagamentosDataset.Name := 'PagamentosDataset';
    PagamentosDataset.AfterApplyUpdates := PagamentosDatasetAfterApplyUpdates;
    PagamentosDataset.EntitySetName := 'Pagamentos';
    PagamentosDataset.Connection := DMConnection.ApiConnection;
    PagamentosDataset.Left := 176;
    PagamentosDataset.Top := 8;
    PagamentosDatasetid.SetParentComponent(PagamentosDataset);
    PagamentosDatasetid.Name := 'PagamentosDatasetid';
    PagamentosDatasetid.FieldName := 'id';
    PagamentosDatasetid.Required := True;
    PagamentosDatasetaliado_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetaliado_id.Name := 'PagamentosDatasetaliado_id';
    PagamentosDatasetaliado_id.FieldName := 'aliado_id';
    PagamentosDatasetaliado_id.Required := True;
    PagamentosDatasetdata_base_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetdata_base_id.Name := 'PagamentosDatasetdata_base_id';
    PagamentosDatasetdata_base_id.FieldName := 'data_base_id';
    PagamentosDatasetdata_base_id.Required := True;
    PagamentosDatasetapagar_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetapagar_id.Name := 'PagamentosDatasetapagar_id';
    PagamentosDatasetapagar_id.FieldName := 'apagar_id';
    PagamentosDatasetapagar_id.Required := True;
    PagamentosDatasetconta_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetconta_id.Name := 'PagamentosDatasetconta_id';
    PagamentosDatasetconta_id.FieldName := 'conta_id';
    PagamentosDatasetconta_id.Required := False;
    PagamentosDatasetmodalidade_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetmodalidade_id.Name := 'PagamentosDatasetmodalidade_id';
    PagamentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    PagamentosDatasetmodalidade_id.Required := False;
    PagamentosDatasetplano_contas_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetplano_contas_id.Name := 'PagamentosDatasetplano_contas_id';
    PagamentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    PagamentosDatasetplano_contas_id.Required := False;
    PagamentosDatasetvalor.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor.Name := 'PagamentosDatasetvalor';
    PagamentosDatasetvalor.FieldName := 'valor';
    PagamentosDatasetvalor.Required := False;
    PagamentosDatasetvalor_desconto.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_desconto.Name := 'PagamentosDatasetvalor_desconto';
    PagamentosDatasetvalor_desconto.FieldName := 'valor_desconto';
    PagamentosDatasetvalor_desconto.Required := False;
    PagamentosDatasetvalor_multa.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_multa.Name := 'PagamentosDatasetvalor_multa';
    PagamentosDatasetvalor_multa.FieldName := 'valor_multa';
    PagamentosDatasetvalor_multa.Required := False;
    PagamentosDatasetvalor_juros.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_juros.Name := 'PagamentosDatasetvalor_juros';
    PagamentosDatasetvalor_juros.FieldName := 'valor_juros';
    PagamentosDatasetvalor_juros.Required := False;
    PagamentosDatasetvalor_outros.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_outros.Name := 'PagamentosDatasetvalor_outros';
    PagamentosDatasetvalor_outros.FieldName := 'valor_outros';
    PagamentosDatasetvalor_outros.Required := False;
    PagamentosDatasetdata.SetParentComponent(PagamentosDataset);
    PagamentosDatasetdata.Name := 'PagamentosDatasetdata';
    PagamentosDatasetdata.FieldName := 'data';
    PagamentosDatasetdata.Required := False;
    PagamentosDatasetcodigo_interno.SetParentComponent(PagamentosDataset);
    PagamentosDatasetcodigo_interno.Name := 'PagamentosDatasetcodigo_interno';
    PagamentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    PagamentosDatasetcodigo_interno.Required := True;
    PagamentosDatasetexcluido.SetParentComponent(PagamentosDataset);
    PagamentosDatasetexcluido.Name := 'PagamentosDatasetexcluido';
    PagamentosDatasetexcluido.FieldName := 'excluido';
    PagamentosDatasetexcluido.Required := False;
    PagamentosDatasetinclusao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetinclusao.Name := 'PagamentosDatasetinclusao';
    PagamentosDatasetinclusao.FieldName := 'inclusao';
    PagamentosDatasetinclusao.Required := False;
    PagamentosDatasetalteracao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetalteracao.Name := 'PagamentosDatasetalteracao';
    PagamentosDatasetalteracao.FieldName := 'alteracao';
    PagamentosDatasetalteracao.Required := False;
    PagamentosDatasetexclusao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetexclusao.Name := 'PagamentosDatasetexclusao';
    PagamentosDatasetexclusao.FieldName := 'exclusao';
    PagamentosDatasetexclusao.Required := False;
    XDataClientPagamentosGet.SetParentComponent(Self);
    XDataClientPagamentosGet.Name := 'XDataClientPagamentosGet';
    XDataClientPagamentosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPagamentosGet, Self, 'OnLoad', 'XDataClientPagamentosGetLoad');
    XDataClientPagamentosGet.Left := 64;
    XDataClientPagamentosGet.Top := 8;
    XDataClientPagamentosDelete.SetParentComponent(Self);
    XDataClientPagamentosDelete.Name := 'XDataClientPagamentosDelete';
    XDataClientPagamentosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPagamentosDelete, Self, 'OnLoad', 'XDataClientPagamentosDeleteLoad');
    SetEvent(XDataClientPagamentosDelete, Self, 'OnError', 'XDataClientPagamentosDeleteError');
    XDataClientPagamentosDelete.Left := 64;
    XDataClientPagamentosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbapagar_id.AfterLoadDFMValues;
    edapagar_id.AfterLoadDFMValues;
    lbconta_id.AfterLoadDFMValues;
    edconta_id.AfterLoadDFMValues;
    lbmodalidade_id.AfterLoadDFMValues;
    edmodalidade_id.AfterLoadDFMValues;
    lbplano_contas_id.AfterLoadDFMValues;
    edplano_contas_id.AfterLoadDFMValues;
    lbvalor.AfterLoadDFMValues;
    edvalor.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    lbvalor_multa.AfterLoadDFMValues;
    edvalor_multa.AfterLoadDFMValues;
    lbvalor_juros.AfterLoadDFMValues;
    edvalor_juros.AfterLoadDFMValues;
    lbvalor_outros.AfterLoadDFMValues;
    edvalor_outros.AfterLoadDFMValues;
    lbdata.AfterLoadDFMValues;
    eddata.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    PagamentosDataset.AfterLoadDFMValues;
    PagamentosDatasetid.AfterLoadDFMValues;
    PagamentosDatasetaliado_id.AfterLoadDFMValues;
    PagamentosDatasetdata_base_id.AfterLoadDFMValues;
    PagamentosDatasetapagar_id.AfterLoadDFMValues;
    PagamentosDatasetconta_id.AfterLoadDFMValues;
    PagamentosDatasetmodalidade_id.AfterLoadDFMValues;
    PagamentosDatasetplano_contas_id.AfterLoadDFMValues;
    PagamentosDatasetvalor.AfterLoadDFMValues;
    PagamentosDatasetvalor_desconto.AfterLoadDFMValues;
    PagamentosDatasetvalor_multa.AfterLoadDFMValues;
    PagamentosDatasetvalor_juros.AfterLoadDFMValues;
    PagamentosDatasetvalor_outros.AfterLoadDFMValues;
    PagamentosDatasetdata.AfterLoadDFMValues;
    PagamentosDatasetcodigo_interno.AfterLoadDFMValues;
    PagamentosDatasetexcluido.AfterLoadDFMValues;
    PagamentosDatasetinclusao.AfterLoadDFMValues;
    PagamentosDatasetalteracao.AfterLoadDFMValues;
    PagamentosDatasetexclusao.AfterLoadDFMValues;
    XDataClientPagamentosGet.AfterLoadDFMValues;
    XDataClientPagamentosDelete.AfterLoadDFMValues;
  end;
end;

end.
